/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.com.mu.logistic.api.LogDataType', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.LogFields', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.LogRequest', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.LogResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.LogFields = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.LogFields, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.LogFields.displayName = 'proto.com.mu.logistic.api.LogFields';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.LogRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.mu.logistic.api.LogRequest.repeatedFields_, null);
};
goog.inherits(proto.com.mu.logistic.api.LogRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.LogRequest.displayName = 'proto.com.mu.logistic.api.LogRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.LogResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.LogResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.LogResponse.displayName = 'proto.com.mu.logistic.api.LogResponse';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.LogFields.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.LogFields.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.LogFields} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.LogFields.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        field: jspb.Message.getFieldWithDefault(msg, 1, ''),
        value: jspb.Message.getFieldWithDefault(msg, 2, ''),
        datatype: jspb.Message.getFieldWithDefault(msg, 3, 0),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.LogFields}
 */
proto.com.mu.logistic.api.LogFields.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.LogFields();
  return proto.com.mu.logistic.api.LogFields.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.LogFields} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.LogFields}
 */
proto.com.mu.logistic.api.LogFields.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setField(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setValue(value);
        break;
      case 3:
        var value = /** @type {!proto.com.mu.logistic.api.LogDataType} */ (reader.readEnum());
        msg.setDatatype(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.LogFields.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.LogFields.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.LogFields} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.LogFields.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getField();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getDatatype();
  if (f !== 0.0) {
    writer.writeEnum(3, f);
  }
};

/**
 * optional string field = 1;
 * @return {string}
 */
proto.com.mu.logistic.api.LogFields.prototype.getField = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.LogFields.prototype.setField = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional string value = 2;
 * @return {string}
 */
proto.com.mu.logistic.api.LogFields.prototype.getValue = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.LogFields.prototype.setValue = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional LogDataType dataType = 3;
 * @return {!proto.com.mu.logistic.api.LogDataType}
 */
proto.com.mu.logistic.api.LogFields.prototype.getDatatype = function () {
  return /** @type {!proto.com.mu.logistic.api.LogDataType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};

/** @param {!proto.com.mu.logistic.api.LogDataType} value */
proto.com.mu.logistic.api.LogFields.prototype.setDatatype = function (value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.mu.logistic.api.LogRequest.repeatedFields_ = [2];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.LogRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.LogRequest.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.LogRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.LogRequest.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        name: jspb.Message.getFieldWithDefault(msg, 1, ''),
        fieldsList: jspb.Message.toObjectList(msg.getFieldsList(), proto.com.mu.logistic.api.LogFields.toObject, includeInstance),
        description: jspb.Message.getFieldWithDefault(msg, 3, ''),
        createdat: jspb.Message.getFieldWithDefault(msg, 4, 0),
        updatedat: jspb.Message.getFieldWithDefault(msg, 5, 0),
        reportedby: jspb.Message.getFieldWithDefault(msg, 6, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.LogRequest}
 */
proto.com.mu.logistic.api.LogRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.LogRequest();
  return proto.com.mu.logistic.api.LogRequest.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.LogRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.LogRequest}
 */
proto.com.mu.logistic.api.LogRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setName(value);
        break;
      case 2:
        var value = new proto.com.mu.logistic.api.LogFields();
        reader.readMessage(value, proto.com.mu.logistic.api.LogFields.deserializeBinaryFromReader);
        msg.addFields(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setDescription(value);
        break;
      case 4:
        var value = /** @type {number} */ (reader.readInt64());
        msg.setCreatedat(value);
        break;
      case 5:
        var value = /** @type {number} */ (reader.readInt64());
        msg.setUpdatedat(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setReportedby(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.LogRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.LogRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.LogRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.LogRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getFieldsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(2, f, proto.com.mu.logistic.api.LogFields.serializeBinaryToWriter);
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getCreatedat();
  if (f !== 0) {
    writer.writeInt64(4, f);
  }
  f = message.getUpdatedat();
  if (f !== 0) {
    writer.writeInt64(5, f);
  }
  f = message.getReportedby();
  if (f.length > 0) {
    writer.writeString(6, f);
  }
};

/**
 * optional string name = 1;
 * @return {string}
 */
proto.com.mu.logistic.api.LogRequest.prototype.getName = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.LogRequest.prototype.setName = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * repeated LogFields fields = 2;
 * @return {!Array<!proto.com.mu.logistic.api.LogFields>}
 */
proto.com.mu.logistic.api.LogRequest.prototype.getFieldsList = function () {
  return /** @type{!Array<!proto.com.mu.logistic.api.LogFields>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.mu.logistic.api.LogFields, 2)
  );
};

/** @param {!Array<!proto.com.mu.logistic.api.LogFields>} value */
proto.com.mu.logistic.api.LogRequest.prototype.setFieldsList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};

/**
 * @param {!proto.com.mu.logistic.api.LogFields=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.mu.logistic.api.LogFields}
 */
proto.com.mu.logistic.api.LogRequest.prototype.addFields = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.com.mu.logistic.api.LogFields, opt_index);
};

/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.logistic.api.LogRequest.prototype.clearFieldsList = function () {
  this.setFieldsList([]);
};

/**
 * optional string description = 3;
 * @return {string}
 */
proto.com.mu.logistic.api.LogRequest.prototype.getDescription = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.LogRequest.prototype.setDescription = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional int64 createdAt = 4;
 * @return {number}
 */
proto.com.mu.logistic.api.LogRequest.prototype.getCreatedat = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.LogRequest.prototype.setCreatedat = function (value) {
  jspb.Message.setProto3IntField(this, 4, value);
};

/**
 * optional int64 updatedAt = 5;
 * @return {number}
 */
proto.com.mu.logistic.api.LogRequest.prototype.getUpdatedat = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.LogRequest.prototype.setUpdatedat = function (value) {
  jspb.Message.setProto3IntField(this, 5, value);
};

/**
 * optional string reportedBy = 6;
 * @return {string}
 */
proto.com.mu.logistic.api.LogRequest.prototype.getReportedby = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.LogRequest.prototype.setReportedby = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.LogResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.LogResponse.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.LogResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.LogResponse.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        result: jspb.Message.getFieldWithDefault(msg, 1, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.LogResponse}
 */
proto.com.mu.logistic.api.LogResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.LogResponse();
  return proto.com.mu.logistic.api.LogResponse.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.LogResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.LogResponse}
 */
proto.com.mu.logistic.api.LogResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setResult(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.LogResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.LogResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.LogResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.LogResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getResult();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
};

/**
 * optional string result = 1;
 * @return {string}
 */
proto.com.mu.logistic.api.LogResponse.prototype.getResult = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.LogResponse.prototype.setResult = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * @enum {number}
 */
proto.com.mu.logistic.api.LogDataType = {
  INT: 0,
  DOUBLE: 1,
  STRING: 2,
  BOOLEAN: 3,
  MAP: 4,
  LIST: 5,
};

goog.object.extend(exports, proto.com.mu.logistic.api);
